import { dataHooks } from '@wix/data-hooks';

export const accordionDataHooks = dataHooks<{
  container: {};
  item: { key: string };
  subitem: { key: string };
}>('accordion');
